import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  input,
  OnInit,
  output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { UserService } from '@app/features/users/user-service';
import { User, UserRole } from '@app/features/users/user.model';
import { RxjsDirective } from '@app/shared/rxjs.directive';
import { Observable } from 'rxjs';
import { UserLabelPipe } from '../user-label-pipe';

@Component({
  selector: 'app-user-menu',
  imports: [CommonModule, MatMenuModule, MatButtonModule, UserLabelPipe, MatIconModule],
  templateUrl: './user-menu.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./user-menu.scss'],
})
export class UserMenu extends RxjsDirective implements OnInit {
  @ViewChild(MatMenu) menu!: MatMenu;
  roles = input<UserRole[]>([]);
  userSelected = output<User>();
  private readonly userService = inject(UserService);
  users$: Observable<User[]> = new Observable<User[]>();

  ngOnInit(): void {
    const roles = this.roles();
    if (roles && roles.length > 0) {
      this.users$ = this.userService.listByRole(roles);
    } else {
      this.users$ = this.userService.allUsers$;
    }
  }

  onClickUser(user: User) {
    this.userSelected.emit(user);
  }
}
